<template>
    <div class='data-express'>
        <!-- 表格展示区域 -->
            <el-form :inline="true">
            <el-form-item>
                <el-button @click="updateHandle"
                    >新增</el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            :data="dataList"
            border
            style="width: 100%">
            <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
            <el-table-column
            prop="timePeriod"
            align="center"
            label="年度"
            width="180">
            </el-table-column>
            <el-table-column
            prop="transaction"
            align="center"
            label="销售额(亿元)"
            width="150">
            </el-table-column>
            <el-table-column
            prop="numericalValue"
            align="center"
            label="数值变化"
            width="180">
                <template slot-scope="scope">
                    {{
                        scope.row.numericalValue*1 > 0
                        ?`上升了${scope.row.numericalValue}%`
                        :`下降了${Math.abs(scope.row.numericalValue)}%`
                    }}
                </template>
            </el-table-column>
            <el-table-column
            prop="description"
            align="center"
            label="描述">
            </el-table-column>

            <el-table-column
            label="操作"
            width="250"
            align="center"
            >
            <template slot-scope="scope">
                <router-link
                    :to="{
                        name:'dataDetail',
                        params:{
                            id:scope.row.id,
                            description:scope.row.description
                        }
                    }" 
                >
                    <el-button
                        type="text"
                        size="small"
                    >
                        详情
                    </el-button>
                </router-link>
                <el-button
                    type="text"
                    size="small"
                    @click="updateHandle(scope.row.id)"
                >
                    修改
                </el-button>
                <el-button
                    type="text"
                     size="small"
                     @click="deleteHandle(scope.row.id)"
                >
                    删除
                </el-button>
            </template>
            </el-table-column>
        </el-table>
        
        <!-- 修改弹窗 -->
        <data-update
            ref="dataUpdate"
            @dataListUpdate='getDataList'
        >
        </data-update>
    </div>

</template>

<script>
import DataUpdate from '@/views/modules/config/child-components/data-update'
  export default {
    data() {
      return {
        dataList: [],//数据快报列表
        // 获取数据快报列表参数
        demandQuery: {
            limit: 10,
            page: 1,
        },       
        totalCount: 0,// 数据快报总数
        loading: false,//是否处于加载中
        isVisible:false,//控制弹窗的显示或隐藏
      }
    },
    mounted(){
        this.getDataList()
    },
    methods: {
        //获取数据快报列表
        getDataList(){
            this.loading = true
            this.$ajaxGet('/bulletin/open/selectDataBulletinList',this.demandQuery).then(({data}) => {
                console.log('data',data)
                if(data.code===0){
                    this.dataList = data.data
                    this.totalCount = data.total
                    this.loading = false;
                    // console.log('datalist',this.dataList)
                }
            })
        },
        //修改按钮的回调
        updateHandle(id){
            this.$nextTick(() => {
                this.$refs.dataUpdate.init(parseInt(id))
            })
        },
        // 删除按钮的回调
        deleteHandle(id){
            this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning", 
            }).then(() => {
                    this.$ajaxPost("/bulletin/delete", [id]).then(
                        ({ data }) => {
                            if (data.code === 0) {
                                this.getDataList();
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                            }
                        }
                    );
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
            
        }
    },
    components:{
        DataUpdate,
    }
  }
</script>

<style scoped lang='less'>
    .data-express{
        // text-align: right;
    }
</style>